// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import Radio from "@insite/mobius/Radio";
import { RadioGroupPresentationProps } from "@insite/mobius/RadioGroup";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";

import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import StepFormRadioButtons from "@store/Library/Components/Bunzl/StepFormComponents/StepFormRadioButtons";
import {
    initialFormState,
    initialSteps,
    useCreditFormContext,
} from "@store/Library/Widgets/CreditForm/CreditFormContextContainer";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface BasicDetailsAccountTypeRadioStyles {
    radioGroup: RadioGroupPresentationProps;
    toolTip: TooltipPresentationProps;
}

const basicDetailsAccountTypeRadioStyles: BasicDetailsAccountTypeRadioStyles = {
    radioGroup: {
        css: css`
            display: flex;
            gap: ${pxToRem(20)};
            align-items: center;
            width: 100%;
            > legend {
                font-size: ${pxToRem(14)};

                float: left;
            }
        `,
    },
    toolTip: {
        mergeCss: true,
        cssOverrides: {
            tooltipWrapper: css`
                top: 0;
            `,
        },
    },
};

const BasicDetailsAccountTypeRadio = () => {
    const { steps, storeKey, setSteps } = useCreditFormContext();
    const bunzlDispatch = useBunzlDispatch();
    const handleCashAccount = () => {
        const stepsWithoutStepThreeAndFour = steps.filter((_, index) => index !== 2 && index !== 3);
        if (steps.length === 3) {
            return;
        }
        setSteps(stepsWithoutStepThreeAndFour);
        bunzlDispatch({
            type: "Data/StepForm/DeleteSteps",
            formKey: storeKey,
            steps: [2, 3],
        });
    };

    const handleCreditAccount = () => {
        if (steps.length === 5) {
            return;
        }
        setSteps(initialSteps);
        bunzlDispatch({
            type: "Data/StepForm/AddSteps",
            formKey: storeKey,
            steps: [
                [2, initialFormState.steps[2]],
                [3, initialFormState.steps[3]],
            ],
        });
    };

    return (
        <StepFormRadioButtons
            validation="taxExempt"
            {...basicDetailsAccountTypeRadioStyles.radioGroup}
            label={siteMessage("CreditForm_AccountType")}
            required
            inputKey="accountType"
        >
            <Radio value={siteMessage("CreditForm_CashAccount") as string} onClick={handleCashAccount}>
                {siteMessage("CreditForm_CashAccount")}
                <Tooltip
                    {...basicDetailsAccountTypeRadioStyles.toolTip}
                    text={siteMessage("CreditForm_CashAccount_Tooltip") as string}
                />
            </Radio>
            <Radio value={siteMessage("CreditForm_TermAccount") as string} onClick={handleCreditAccount}>
                {siteMessage("CreditForm_TermAccount")}
                <Tooltip
                    {...basicDetailsAccountTypeRadioStyles.toolTip}
                    text={siteMessage("CreditForm_TermAccount_Tooltip") as string}
                />
            </Radio>
        </StepFormRadioButtons>
    );
};

export default BasicDetailsAccountTypeRadio;
